import pb from '../lib/pocketbase';

/**
 * Fetch a paginated list of corredores from the database.
 * @param {number} page - The page number.
 * @param {number} perPage - The number of items per page.
 * @returns {Object} - A list of corredores and pagination details.
 */
export async function getCorredores(page, perPage) {
  return await pb.collection('corredor').getList(page, perPage, {
    sort: '-created', // Sort by creation date in descending order
    $autoCancel: false, // Prevent automatic cancellation of the request
    expand: 'rutaAsignada', // Expand related fields (if applicable)
  });
}

/**
 * Create a new corredor in the database.
 * @param {Object} corredor - The corredor object to create.
 * @returns {Object} - The created corredor.
 */
export async function createCorredor(corredor) {
  return await pb.collection('corredor').create(corredor);
}

/**
 * Update an existing corredor in the database.
 * @param {string} id - The ID of the corredor to update.
 * @param {Object} corredor - The updated corredor object.
 * @returns {Object} - The updated corredor.
 */
export async function updateCorredor(id, corredor) {
  return await pb.collection('corredor').update(id, corredor);
}

/**
 * Delete a corredor from the database.
 * @param {string} id - The ID of the corredor to delete.
 * @returns {boolean} - True if the deletion was successful.
 */
export async function deleteCorredor(id) {
  return await pb.collection('corredor').delete(id);
}